import React from 'react'
import * as styles from './button.module.css'

import { Link } from 'gatsby'
import AgnosticLink from './AgnosticLink.js'
import { rhythm } from '../utils/typography.js'

function appendClass(classList, className) {
  classList += ` ${styles[className]}`;
}

export default class Button extends React.Component {
  render() {
    const { 
      children, 
      to, 
      className = '', 
      blue,
      darkblue,
      vscodevim,
      purple,
      darkpurple,
      pink,
      green,
      darkgreen,
      pixelated,
      black,
      currentText,
      ...rest } = this.props
    let classes = `${styles.button} ${className}`
    if (blue) classes += ` ${styles.blue}`
    if (darkblue) classes += ` ${styles.darkblue}`
    if (vscodevim) classes += ` ${styles.vscodevim}`
    if (purple) classes += ` ${styles.purple}`
    if (pink) classes += ` ${styles.pink}`
    if (darkpurple) classes += ` ${styles.darkpurple}`
    if (green) classes += ` ${styles.green}`
    if (darkgreen) classes += ` ${styles.darkgreen}`
    if (pixelated) classes += ` ${styles.pixelated}`
    if (black) classes += ` ${styles.black}`
    if (currentText) classes += ` ${styles.currentText}`

    return (
      <AgnosticLink className={classes} href={to} {...rest}>
        {children}
      </AgnosticLink>
    )
  }
}

export const ButtonPagination = ({ to, children, pixelated, black, className, ...rest }) => {
  className = `${styles.button} ${styles.pagination} ${className}`
  if (pixelated) className = `${className} ${styles.pixelated}`
  if (black) className = `${className} ${styles.black}`

  if (!to)
    return (
      <a className={className} {...rest}>
        {children}
      </a>
    )
  else
    return (
      <Link className={className} to={to} {...rest}>
        {children}
      </Link>
    )
}

export const TweetButton = ({ url, title = '', tags = [] }) => {
  tags = tags || [] // tags can be null which bypasses defaults
  const text = `I really enjoyed this article on Barbarian Meets Coding: ${title}`
  const hashtags = tags.slice(0, Math.min(tags.length, 2)).join(',') // pick only 3 tags
  const encodedUrl = encodeURI(url)
  const via = 'vintharas'
  const tweetLink = `https://twitter.com/intent/tweet?hashtags=${hashtags}&original_referer=${encodedUrl}&text=${encodeURI(
    text
  )}&url=${encodedUrl}&via=${via}`
  return (
    <footer style={{ display: 'flex', marginBottom: rhythm(1) }}>
      <Button style={{ flex: 1, textAlign: 'center' }} href={tweetLink}>
        Spread The Word. Share this article!
      </Button>
    </footer>
  )
}
